export const parseRangeIntoIntegers = (str: string) => {
    const trimmed = str.trim()
    if (!trimmed) return []

    let integers: any[] = []

    if (/^\d+$/.test(trimmed)) {
        const num = parseInt(trimmed, 10)
        integers = [num]

        return integers
    }

    const rangeMatch = trimmed.match(/^(\d+)\s*-\s*(\d+)$/)
    if (rangeMatch) {
        const start = parseInt(rangeMatch[1], 10)
        const end = parseInt(rangeMatch[2], 10)

        for (let i = start; i <= end; i++) {
            integers.push(i)
        }
        return integers
    }

    return integers
}
